import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../model/hooks';
import '../../common/style/LinkLabel.css';
import { LinkText, PrimaryButton } from '../../components/index';
import { RedirectLogin } from '../../components/templates';
export const Top = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const { loading, error, loginWithEmail } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const onSubmitLogin = async (e) => {
        var _a;
        (_a = e) === null || _a === void 0 ? void 0 : _a.preventDefault();
        await loginWithEmail(email, password);
    };
    const onClickResetPass = () => history.push('/pass_reset');
    return (React.createElement(SContainer, null,
        React.createElement(RedirectLogin, null),
        React.createElement(Grid, { container: true, alignItems: "center", justify: "center" },
            React.createElement(Grid, { item: true, xs: 9, sm: 6, md: 3 },
                React.createElement(STitle, null, t('IMORY')),
                React.createElement(SPaper, { elevation: 4 },
                    React.createElement(SLogin, null, t('ログイン')),
                    React.createElement(SDivider, null),
                    React.createElement(SForm, { autoComplete: "off" },
                        React.createElement(STextField, { label: t('メールアドレス'), defaultValue: email, variant: "outlined", size: "small", onChange: (e) => setEmail(e.target.value) }),
                        React.createElement(STextField, { label: t('パスワード'), defaultValue: password, variant: "outlined", size: "small", type: "password", onChange: (e) => setPassword(e.target.value) }),
                        React.createElement(SErrorArea, null, error),
                        React.createElement(SButtonArea, null,
                            React.createElement(PrimaryButton, { type: "submit", fullWidth: true, loading: loading, disabled: email === '' || password === '', onClick: onSubmitLogin }, t('ログイン')))),
                    React.createElement(LinkText, { onClick: onClickResetPass }, t('パスワードを忘れた方はこちら')))))));
};
const SContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const SPaper = styled(Paper) `
  padding: 42px 36px 12px 36px;
  text-align: center;
`;
const STitle = styled.p `
  font-size: 40px;
  text-align: center;
`;
const SLogin = styled.p `
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;
const SDivider = styled(Divider) `
  &&& {
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;
const SForm = styled.form `
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const STextField = styled(TextField) `
  &&& {
    margin: 6px 0;
  }
`;
const SButtonArea = styled.div `
  padding-top: 18px;
`;
const SErrorArea = styled.div `
  color: red;
`;
